//Video background
let timeoutId,
    $videoBgAspect = $(".videobg-aspect"),
    $videoBgWidth = $(".videobg-width"),
    videoAspect = $videoBgAspect.outerHeight() / $videoBgAspect.outerWidth();

function videobgEnlarge() {
    let windowAspect = $(window).height() / $(window).width();
    if(windowAspect > videoAspect) {
        $videoBgWidth.width(`${windowAspect / videoAspect * 100}%`);
    } else {
        $videoBgWidth.width(`${100}%`);
    }
}

$(window).resize(function() {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(videobgEnlarge, 100);
});

function setVideoFrame() {
    const iframes = document.querySelectorAll('iframe.load');

    iframes.forEach(iframe => {
        iframe.src = iframe.dataset.src;
    });
}

$(function() {
    videobgEnlarge();

    if (window.addEventListener)  // W3C DOM
        window.addEventListener('load', setVideoFrame, false);
    else if (window.attachEvent) { // IE DOM
        window.attachEvent('onload', setVideoFrame);
    } else { //NO SUPPORT, lauching right now
        setVideoFrame();
    }
});